import React, { useEffect } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const LabelPrintComponent = ({ responseData, onComplete }) => {
    useEffect(() => {
        if (responseData && Array.isArray(responseData)) {
            generatePDF(responseData);
        }
    }, [responseData]);

    const generatePDF = (data) => {
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'in',
            format: [8.5, 11],
        });
                const currentDateTime = new Date().toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        }).replace(/[,\/:]/g, '-');
        doc.setProperties({
            title: `PandaGoGoGo Order Labels ${currentDateTime}`
        });
        const labelWidth = 4;
        const labelHeight = 1.4;
        const marginX = 0.25;
        const marginY = 0.60;
        const labelsPerRow = 2;
        const labelsPerColumn = 5;
        const labelsPerSheet = labelsPerRow * labelsPerColumn;
        const maxTextWidth = labelWidth - 0.2;

        data.forEach((item, index) => {
            if (index > 0 && index % labelsPerSheet === 0) doc.addPage();

            const labelIndex = index % labelsPerSheet;
            const row = Math.floor(labelIndex / labelsPerRow);
            const col = labelIndex % labelsPerRow;

            const x = marginX + col * (labelWidth + marginX);
            const y = marginY + row * (labelHeight + marginY);

            doc.setFontSize(11);

            // Helper function to wrap text
            const wrapText = (text: string, x: number, y: number, maxWidth: number, lineHeight = 0.2) => {
                const words = text.split(' ');
                let line = '';
                const lines: string[] = [];
                let currentY = y;

                for (let word of words) {
                    const testLine = line + (line ? ' ' : '') + word;
                    const metrics = doc.getTextWidth(testLine);
                    if (metrics <= maxWidth) {
                        line = testLine;
                    } else {
                        if (line) {
                            lines.push(line);
                            currentY += lineHeight;
                        }
                        line = word;
                    }
                }
                if (line) {
                    lines.push(line);
                }

                lines.forEach((line, i) => {
                    doc.text(line, x, y + i * lineHeight);
                });
                return lines.length * lineHeight;
            };

            // Restaurant
            doc.setFont("helvetica", "bold");
            let currentY = y + 0.4;
            // doc.text("Restaurant:", x + 0.1, currentY);
            // doc.setFont("helvetica", "normal");
            currentY += wrapText(`${item.restaurentName}`, x + 0.1, currentY, maxTextWidth);

            // Customer
            doc.setFont("helvetica", "bold");
            doc.text("Customer:", x + 0.1, currentY);
            doc.setFont("helvetica", "normal");
            currentY += wrapText(`${item.userName}`, x + 1.0, currentY, maxTextWidth - 0.9); // Adjust for label width

            // Dish
            doc.setFont("helvetica", "bold");
            doc.text("Dish:", x + 0.1, currentY);
            doc.setFont("helvetica", "normal");
            currentY += wrapText(`${item.menuName}`, x + 1.0, currentY, maxTextWidth - 0.9);

            // Location
            doc.setFont("helvetica", "bold");
            doc.text("Location:", x + 0.1, currentY);
            doc.setFont("helvetica", "normal");
            wrapText(`${item.pickupAddress}`, x + 1.0, currentY, maxTextWidth - 0.9);

            // Commented code preserved
            //   doc.text(`Customer: ${item.userName}`, x + 0.1, y + 0.4);
            //   doc.text(`Restaurant: ${item.restaurentName}`, x + 0.1, y + 0.6);
            //   doc.text(`Dish: ${item.menuName}`, x + 0.1, y + 0.8);
            //   doc.text(`Amount: $${item.amount}`, x + 0.1, y + 1.0);
            //   doc.text(`Location: ${item.pickupAddress}`, x + 0.1, y + 1.2);
        });
        window.open(doc.output('bloburl'), '_blank');
        if (onComplete) onComplete();
    };

    return null;
};

export default LabelPrintComponent;
